<button mat-raised-button color="primary" (click)="openPowerProfileModal()">
    {{ 'devices.data.buttons.request_power_profile' | translate }}
</button>
